import oneAppMiddleware from './one-app-middleware';
import subscribe from './subscribe-to-one-app';
import publish from './publish-to-one-app';

export default function createOneAppMiddleware(config) {
  return oneAppMiddleware({ subscribe, publish, ...config });
}
